import { createWebHistory, createRouter } from "vue-router";

// layouts

import Auth from "../layouts/Auth.vue";
import Admin from "../layouts/Admin.vue";

// views for Admin layout
import AdminBaseDataTable from "../views/admin/BaseDataTable.vue";

import AdminCollaborationRequestDetail from "../views/admin/CollaborationRequestDetail.vue";

import AdminRssFeedDisciplines from "../views/admin/RssFeedDisciplines.vue";
import AdminRssFeedItems from "../views/admin/RssFeedItems.vue";
import AdminRolePermissions from "../views/admin/RolePermissions.vue";
import AdminFinance from "../views/admin/Finance.vue";
import AdminExpertNewsletter from "../views/admin/ExpertNewsletter.vue";
import AdminExpertRecommendations from "../views/admin/ExpertRecommendations.vue";
import AdminCollaboragent from "../views/admin/Collaboragent.vue";
import AdminSourcesOfNote from "../views/admin/SourcesOfNote.vue";
import AdminResearchCompassPipeline from "../views/admin/ResearchCompassPipeline.vue";
import AdminDataIntegrity from "../views/admin/DataIntegrity.vue";
import AdminDataIntegritySchools from "../views/admin/DataIntegritySchools.vue";
import AdminDataIntegrityResearchInterests from "../views/admin/DataIntegrityResearchInterests.vue";
import AdminProfileSearch2 from "../views/admin/ProfileSearch2.vue";
import AdminEFeedItemSearch from "../views/admin/eFeedItemSearch.vue";
import AdminEmailTemplates from "../views/admin/EmailTemplates.vue";
import AdminContracts from "../views/admin/Contracts.vue";
import Settings from "../views/Settings.vue";
import Stats from "../views/Stats.vue";
import AdminMap from "../views/admin/Map.vue";
import Wrapped from "../views/Wrapped.vue";

import PreviewProfile from "../views/admin/PreviewProfile.vue";

// views for Auth layout
import Login from "../views/auth/Login.vue";
import Logout from "../views/auth/Logout.vue";

import AdminClientCards from "../views/admin/ClientCards.vue";

// Dev only - UI example playground
import AdminPlayground from "../views/admin/Playground.vue";

// all routes need names for us to properly push page transitions to PostHog
const routes = [
  {
    name: "Admin",
    path: "/admin",
    component: Admin,
    children: [
      {
        name: "Stats",
        path: "/admin",
        component: Stats,
      },
      {
        name: "Settings",
        path: "/admin/settings",
        component: Settings,
      },
      {
        name: "Wrapped",
        path: "/admin/wrapped",
        component: Wrapped,
      },
      {
        name: "AdminMap",
        path: "/admin/map",
        component: AdminMap,
      },
      {
        name: "AdminContracts",
        path: "/admin/contracts",
        component: AdminContracts,
      },
      {
        name: "AdminFinance",
        path: "/admin/finance",
        component: AdminFinance,
      },

      {
        name: "AdminCollaborationRequestDetail",
        path: "/admin/collaboration-requests/detail/:hashedId",
        component: AdminCollaborationRequestDetail,
      },
      {
        name: "AdminCollaborationRequestDetailWithRequest",
        path: "/admin/collaboration-requests/detail/:hashedId/profile/:profileHashedId",
        component: AdminCollaborationRequestDetail,
      },
      {
        name: "AdminExpertRecommendations",
        path: "/admin/collaboration-spaces/:hashedId/expert-recommendations",
        component: AdminExpertRecommendations,
      },
      {
        name: "AdminRolePermissions",
        path: "/admin/role-permissions",
        component: AdminRolePermissions,
      },
      {
        name: "PreviewProfile",
        path: "/admin/preview-profile/:hashedId",
        component: PreviewProfile,
      },
      {
        name: "AdminRssFeedDisciplines",
        path: "/admin/rss-feed-disciplines",
        component: AdminRssFeedDisciplines,
      },
      {
        name: "AdminRssFeedItems",
        path: "/admin/rss-feed-items",
        component: AdminRssFeedItems,
      },
      {
        name: "AdminDataIntegrity",
        path: "/admin/data-integrity",
        component: AdminDataIntegrity,
      },
      {
        name: "AdminExpertNewsletter",
        path: "/admin/expert-newsletter",
        component: AdminExpertNewsletter,
      },
      {
        name: "AdminCollaboragent",
        path: "/admin/collaboragent",
        component: AdminCollaboragent,
      },
      {
        name: "AdminSourcesOfNote",
        path: "/admin/sources-of-note",
        component: AdminSourcesOfNote,
      },
      {
        name: "AdminResearchCompassPipeline",
        path: "/admin/research-compass-pipeline",
        component: AdminResearchCompassPipeline,
      },
      {
        name: "AdminDataIntegritySchools",
        path: "/admin/data-integrity/schools",
        component: AdminDataIntegritySchools,
      },
      {
        name: "AdminDataIntegrityResearchInterests",
        path: "/admin/data-integrity/research-interests",
        component: AdminDataIntegrityResearchInterests,
      },
      {
        name: "AdminProfileSearch2",
        path: "/admin/profile-search-2",
        component: AdminProfileSearch2,
      },
      {
        name: "AdminProfileSearch2WithProfile",
        path: "/admin/profile-search-2/:hashedId",
        component: AdminProfileSearch2,
      },
      {
        name: "AdminEFeedItemSearch",
        path: "/admin/e-feed-item-search",
        component: AdminEFeedItemSearch,
      },
      {
        name: "AdminEmailTemplates",
        path: "/admin/email-templates",
        component: AdminEmailTemplates,
      },
      {
        name: "AdminEmailTemplatesItem",
        path: "/admin/email-templates/:id",
        component: AdminEmailTemplates,
      },
      {
        name: "AdminClientCards",
        path: "/admin/client-cards",
        component: AdminClientCards,
      },
      {
        name: "AdminBaseDataTableNestedItem",
        path: "/admin/:itemType0/:action0/:hashedId0/:itemType1/:action1/:hashedId1",
        component: AdminBaseDataTable,
      },
      {
        name: "AdminBaseDataTableCreateNestedItem",
        path: "/admin/:itemType0/:action0/:hashedId0/:itemType1/:action1",
        component: AdminBaseDataTable,
      },
      {
        name: "AdminBaseDataTableItem",
        path: "/admin/:itemType0/:action0/:hashedId0",
        component: AdminBaseDataTable,
      },
      {
        name: "AdminBaseDataTableCreateItem",
        path: "/admin/:itemType0/:action0",
        component: AdminBaseDataTable,
      },
      {
        name: "AdminBaseDataTable",
        path: "/admin/:itemType0",
        component: AdminBaseDataTable,
      },
    ],
  },
  {
    name: "Auth",
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        name: "Login",
        path: "/auth/login",
        component: Login,
      },
      {
        name: "Logout",
        path: "/auth/logout",
        component: Logout,
      },
    ],
  },
  {
    name: "AuthRedirect",
    path: "/",
    redirect: "/auth",
  },
  { name: "GeneralRedirect", path: "/:pathMatch(.*)*", redirect: "/" },
];

if (import.meta.env.MODE === "development") {
  const exampleUIPlaygroundRoute = {
    name: "AdminPlayground",
    path: "/admin/playground",
    component: AdminPlayground,
  };

  routes[0].children.push(exampleUIPlaygroundRoute);
}
// Dev only end

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
